<div>
	<div style="padding: 10px; background-color: #ebebeb">
		<button [ngClass]="this.isCustom == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 0px" (click)="onCustom()">Custom</button>
		<button [ngClass]="this.isPortrait == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 5px" (click)="onPortrait()">Portrait</button>
		<button [ngClass]="this.isLandscape == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 5px" (click)="onLandscape()">Landscape</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onRotateCanvas()">Rotate</button>
		<button [ngClass]="this.cropperTransform.flipH == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 5px" (click)="onFlipImageH()">
			Flip H
		</button>
		<button [ngClass]="this.cropperTransform.flipV == true ? 'btn btn-warning' : 'btn btn-primary'" style="margin-left: 5px" (click)="onFlipImageV()">
			Flip V
		</button>
		<button class="btn btn-info" style="margin-left: 15px" (click)="onRestore()">Restore</button>
		<button class="btn btn-info" style="margin-left: 5px" (click)="onExport()">Export</button>
	</div>

	<br />

	<!-- 				     -->
	<!-- Display When Loaded -->
	<!-- 				     -->
	<div class="image-editor">
		<div id="div_edit" class="image-editor-edit">
			<img class="busy-img" [style.display]="isLoaded == true ? 'none' : 'block'" src="assets/images/loading.gif" />

			<image-cropper
				class="cropper"
				[style.visibility]="isLoaded == true ? 'visible' : 'hidden'"
				format="jpeg"
				[aspectRatio]="cropperAspectRatio"
				[maintainAspectRatio]="cropperMaintainAspectRatio"
				[canvasRotation]="cropperCanvasRotation"
				[transform]="cropperTransform"
				[autoCrop]="true"
				[imageBase64]="cropperImageBase64"
				(imageCropped)="cropperImageCropped($event)"
				(imageLoaded)="cropperImageLoaded($event)"
				(cropperReady)="cropperReady()"
				(loadImageFailed)="cropperLoadImageFailed()"
			></image-cropper>
		</div>

		<div style="width: 35px; background-color: #ebebeb"></div>
		<!-- div Spacer -->

		<div id="div_view" class="image-editor-view">
			<img class="image-editor-view-img" [src]="cropperCroppedWorkImage" [style.visibility]="isLoaded == true ? 'visible' : 'hidden'" />
		</div>
	</div>

	<br />

	<div style="padding: 10px; background-color: #ebebeb">
		<!-- filterGrayscale -->
		<div class="filter-editor">
			<mat-slide-toggle class="myClass" [(ngModel)]="filterGrayscale" (change)="setGrayscaleValue($event)"></mat-slide-toggle>
			<div class="filter-editor" style="width: 75px"></div>
		</div>

		<div class="filter-editor">
			<label>Grayscale</label>
			<div class="filter-editor" style="width: 75px"></div>
		</div>

		<!-- filterBrightness -->
		<div class="filter-editor">
			<input type="range" min="-100" max="100" class="slider" [(ngModel)]="filterBrightness" (change)="setBrightnessValue($event)" />

			<div class="filter-editor" style="width: 75px">
				<button class="btn-xs btn-primary" (click)="onBrightnessReset()">Reset</button>
			</div>
		</div>

		<div class="filter-editor">
			<label>Brightness: {{ filterBrightness }}%</label>
			<div class="filter-editor" style="width: 75px"></div>
		</div>

		<!-- filterContrast -->
		<div class="filter-editor">
			<!-- Note: for realtime update of value, use:  (input)="setBrightnessValue($event)"	-->
			<input type="range" min="-100" max="100" class="slider" [(ngModel)]="filterContrast" (change)="setContrastValue($event)" />

			<div class="filter-editor" style="width: 75px">
				<button class="btn-xs btn-primary" (click)="onContrastReset()">Reset</button>
			</div>
		</div>

		<div class="filter-editor">
			<label>Contrast: {{ filterContrast }}%</label>
			<div class="filter-editor" style="width: 75px"></div>
		</div>

		<br />

		<button class="btn btn-primary" style="margin-left: 0px" (click)="onSave()">Save</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
	</div>
</div>
